<template>
  <div class="container">
    <div class="image-caption__wrapper">
      <div
        class="image-caption"
        :class="{ 'image-caption--left': slide.textAlignment === 'Left' }"
        v-for="(slide, slideIndex) in slides"
        :key="slideIndex"
      >
        <div
          class="image-caption__image"
          :style="`background-image: url(${slide.image});`"
        ></div>
        <div class="image-caption__container">
          <div class="image-caption__title" v-html="slide.caption"></div>
          <div class="image-caption__title" v-if="slide.captionReadMore && readMore === slideIndex" v-html="slide.captionReadMore"></div>
          <a href="#" class="image-caption__read-more" v-if="slide.captionReadMore" @click.prevent="toggleReadMore(slideIndex)">{{ readMore === slideIndex ? "Read Less" : "Read More" }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slides"],
  mounted() {
    this.$nextTick(() => {
      this.setCarouselPadding();
    });
  },
  data() {
    return {
        paddingLeft: 40,
        readMore: null,
    };
  },
    methods: {
    toggleReadMore: function (index) {
        if (this.readMore === index) {
            this.readMore = null;
        } else {
            this.readMore = index;
        }
    },
    setCarouselPadding: function () {
      this.setCarouselPaddingLeft();
      let self = this;
      window.addEventListener("resize", function () {
        self.setCarouselPaddingLeft();
      });
    },
    setCarouselPaddingLeft: function () {
      let value =
        document.querySelector(".image-caption-slider__heading").offsetLeft +
        16;
      this.paddingLeft = value == 0 ? "12" : value;
    },
  },
};
</script>
